import React from 'react';
import PageBottom from './page-bottom/PageBottom';
import OtpComponent from './otp-component/OtpComponent';
const MobileOtpVerification = () => {
  return (
    <div className='row justify-content-center align-items-center h-100'>
      <div className='col-sm-3 px-0'>
        <OtpComponent type='mobile' />
        <PageBottom />
      </div>
    </div>
  );
};

export default MobileOtpVerification;
